import Unicon from 'vue-unicons'

import {
    uniSearchAlt,
    uniCommentAltSearch,
    uniCommentsAlt,
    uniRobot,
    uniEye,
    uniEyeSlash,
    uniSignout,
    uniFilter,
    uniGrids,
    uniMessage,
    uniTopArrowFromTop,
    uniAngleUp,
    uniAngleDown,
    uniPaperclip,
    uniGrin,
    uniMicrophone,
    uniBell,
    uniArrowLeft,
    uniCheck,
    uniEnvelopeTimes,
    uniTimes,
    uniCornerUpRightAlt,
    uniPhoneAlt,
    uniListUl,
    uniPlus,
    uniTrashAlt,
    uniComments,
    uniHistoryAlt,
    uniListUiAlt,
    uniComment,
    uniChartBar,
    uniCommentAltBlock,
    uniCommentChartLine,
    uniCommentAltVerify,
    uniExternalLinkAlt,
    uniSave,
    uniCommentAltEdit,
    uniMoon,
    uniRefresh,
    uniSync,
    uniEstate,
    uniCommentAltLines,
    uniCommentAltDots,
    uniBright,
    uniSlidersVAlt,
    uniCommentAltPlus,
    uniEllipsisV,
    uniArrow,
    uniFastMail,
    uniDownloadAlt,
    uniArrowsShrinkV,
    uniPrint,
    uniTimesSquare,
    uniSearch,
    uniCopy,
    uniCopyAlt,
    uniUserSquare,
    uniImage,
    uniFileBlank,
    uniUserCircle,
    uniUsersAlt,
    uniUser,
    uniUserPlus,
    uniUserMinus,
    uniMinus,
    uniAlignCenterV,
    uniCommentQuestion,
    uniLink,
    uniInstagram,
    uniFacebookMessenger,
    uniEditAlt,
    uniQrcodeScan,
    uniWifiSlash,
    uniWifi,
    uniShareAlt,
    uniBookmark,
    uniShieldQuestion,
    uniExchangeAlt,
    uniEnvelopeSend,
    uniMapPin,
    uniCornerUpLeftAlt,
    uniFavorite,
    uniProcess,
    uniClockEight,
    uniBill,
    uniCheckCircle,
    uniInvoice,
    uniAnalysis,
    uniArrowToBottom,
    uniCloudQuestion,
    uniEnvelope,
    uniPhone,
    uniCalendarAlt,
    uniMobileAndroid,
    uniFile,
    uniDollarSignAlt,
    uniHdd,
    uniSlidersV,
    uniFolder,
    uniPlay,
    uniSortAmountDown,
    uniSortAmountUp,
    uniCommentCheck,
    uniCommentSlash,
    uniStopwatch,
    uniStopwatchSlash,
    uniChannel,
    uniCloudComputing,
    uniDatabaseAlt,
    uniLayerGroup,
    uniDataSharing,
    uniUpload,
    uniCircle,
    uniFileAlt,
    uniArrowRight,
    uniShieldCheck,
    uniFrown,
    uniExclamationTriangle,
    uniExchange,
    uniImport,
    uniExport,
    uniFilterSlash,
    uniArrowDown,
    uniArrowUp,
    uniFileCheckAlt,
    uniExpandArrows,
    uniExpandArrowsAlt,
    uniCommentSearch,
    uniDraggabledots,
    uniDocumentLayoutLeft,
    uniCommentAltSlash,
    uniEdit,
    uniPricetagAlt,
    uniTagAlt,
    uniLock,
    uniUnlock,
    uniSpinnerAlt,
    uniSpinner,
    uniUserExclamation,
    uniClipboardNotes,
    uniMobileAndroidAlt,
    uniArrowCircleDown,
} from 'vue-unicons/dist/icons'

Unicon.add([
    uniAngleUp,
    uniArrowsShrinkV,
    uniMinus,
    uniAlignCenterV,
    uniPrint,
    uniTimesSquare,
    uniUserSquare,
    uniCloudQuestion,
    uniEstate,
    uniSlidersVAlt,
    uniFastMail,
    uniSearchAlt,
    uniCommentAltSearch,
    uniCommentAltPlus,
    uniCommentAltDots,
    uniCommentsAlt,
    uniRobot,
    uniEye,
    uniEyeSlash,
    uniSignout,
    uniBright,
    uniEllipsisV,
    uniFilter,
    uniGrids,
    uniMessage,
    uniTopArrowFromTop,
    uniAngleDown,
    uniPaperclip,
    uniGrin,
    uniMicrophone,
    uniBell,
    uniArrowLeft,
    uniCheck,
    uniEnvelopeTimes,
    uniTimes,
    uniCornerUpRightAlt,
    uniPhoneAlt,
    uniListUl,
    uniPlus,
    uniTrashAlt,
    uniComments,
    uniHistoryAlt,
    uniListUiAlt,
    uniComment,
    uniChartBar,
    uniCommentAltBlock,
    uniCommentChartLine,
    uniCommentAltVerify,
    uniExternalLinkAlt,
    uniSave,
    uniCommentAltLines,
    uniCommentAltEdit,
    uniMoon,
    uniSearch,
    uniRefresh,
    uniArrow,
    uniDownloadAlt,
    uniCopy,
    uniCopyAlt,
    uniImage,
    uniFileBlank,
    uniUserCircle,
    uniUsersAlt,
    uniUser,
    uniUserPlus,
    uniUserMinus,
    uniCommentQuestion,
    uniLink,
    uniInstagram,
    uniFacebookMessenger,
    uniEditAlt,
    uniQrcodeScan,
    uniWifiSlash,
    uniBookmark,
    uniShieldQuestion,
    uniWifi,
    uniShareAlt,
    uniProcess,
    uniClockEight,
    uniBill,
    uniCheckCircle,
    uniInvoice,
    uniAnalysis,
    uniArrowToBottom,
    uniExchangeAlt,
    uniEnvelopeSend,
    uniMapPin,
    uniCornerUpLeftAlt,
    uniFavorite,
    uniEnvelope,
    uniPhone,
    uniCalendarAlt,
    uniMobileAndroid,
    uniFile,
    uniDollarSignAlt,
    uniHdd,
    uniSlidersV,
    uniFolder,
    uniPlay,
    uniSortAmountDown,
    uniSortAmountUp,
    uniCommentCheck,
    uniCommentSlash,
    uniStopwatch,
    uniStopwatchSlash,
    uniChannel,
    uniCloudComputing,
    uniDatabaseAlt,
    uniLayerGroup,
    uniDataSharing,
    uniUpload,
    uniCircle,
    uniFileAlt,
    uniArrowRight,
    uniShieldCheck,
    uniFrown,
    uniExclamationTriangle,
    uniExchange,
    uniImport,
    uniExport,
    uniFilterSlash,
    uniArrowDown,
    uniArrowUp,
    uniFileCheckAlt,
    uniExpandArrows,
    uniExpandArrowsAlt,
    uniCommentSearch,
    uniDraggabledots,
    uniDocumentLayoutLeft,
    uniCommentAltSlash,
    uniEdit,
    uniPricetagAlt,
    uniTagAlt,
    uniLock,
    uniUnlock,
    uniSync,
    uniSpinnerAlt,
    uniSpinner,
    uniUserExclamation,
    uniClipboardNotes,
    uniMobileAndroidAlt,
    uniArrowCircleDown,
])

export { Unicon }
